import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { Button } from '@cordata/buffet';

import { authorizedPyInstance as py } from '~/utils';
import { LoadingModal } from '~/components';

const PDFDownloadButton = ({ endpoint, icon, label }) => {
  const [link, setLink] = useState();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isCanceled, setIsCanceled] = useState(false);

  const downloadPdf = () => {
    setIsModalOpen(true);
    setIsCanceled(false);

    py
      .get(endpoint)
      .then((r) => {
        setLink(r.data.data.link);
      })
      .finally(() => {
        setIsModalOpen(false);
      });
  };

  const cancelDownload = () => {
    setIsModalOpen(false);
    setIsCanceled(true);
  };

  useEffect(() => {
    if (link && !isCanceled) {
      window.open(link, '_blank');
    }
  }, [link]);

  return (
    <>
      <Button
        outline
        color="tertiary"
        className="cursor-default font-weight-bold"
        onClick={downloadPdf}
      >
        { icon && (
          <FontAwesomeIcon icon={icon} className="text-primary" />
        )}
        &nbsp; {label}
      </Button>

      <LoadingModal
        isOpen={isModalOpen}
        toggle={cancelDownload}
        headerText="Downloading..."
        message="Please wait as we prepare the file for download."
      />
    </>
  );
};

PDFDownloadButton.propTypes = {
  endpoint: PropTypes.string.isRequired,
  icon: PropTypes.string,
  label: PropTypes.string,
};

PDFDownloadButton.defaultProps = {
  icon: 'file-export',
  label: 'PDF',
};

export default PDFDownloadButton;
